package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel

data class ModalGuidanceState(
    val show: Boolean = false,
    val question: InspectionTemplateQuestionModel? = null
)
